import(/* webpackMode: "eager" */ "D:\\portal\\fsms-fe\\src\\app\\(ptl)\\pbc\\sgqi\\oatig\\list\\page.tsx");
